import GetWidgetHostConfigAsyncRequestModelBase from '../_generated/modelBases/get-widget-host-config-async-request-model-base';

export default class GetWidgetHostConfigAsyncRequestModel extends GetWidgetHostConfigAsyncRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
